import { Map } from "ol";
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Point from "ol/geom/Point";
import { transform } from "ol/proj";
import { DamListDto } from "~/api/GeneratedApi";
import { LayerTitle } from "../types/layers";
import { CustomMapEventTypes } from "../types/map";
import { damToMapItem } from "./dataConverters";
import { findSourceByTitle } from "./findSourceByTitle";

export function addDamsToMap(
  map: Map,
  dams: DamListDto[],
  allowInactive = false,
): void {
  // Find the dams layer and add the dams as features
  const source = findSourceByTitle(map, LayerTitle.Dams);
  // Clear the source before adding
  source.clear();
  const features: Feature<Geometry>[] = [];
  dams.forEach((e) => {
    // Convert to internal type
    const convertedDam = damToMapItem(e);
    if (!convertedDam.active && !allowInactive) return;
    // Dam locations are in EPSG:4326 in db
    const transformed = transform(
      [convertedDam.location.x, convertedDam.location.y],
      "EPSG:4326",
      "EPSG:3857",
    );
    const point = new Point(transformed);
    const feat = new Feature({
      geometry: point,
    });
    feat.setProperties({ ...convertedDam });
    feat.set("overlayOffsetY", -24);
    feat.setId(convertedDam.mapId);
    features.push(feat);
  });
  source.addFeatures(features);
  source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
  map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
}
